export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_07.22d637e7.mp4";